// Zweck: Gerätezugriffe über die bestehende One360-Anmeldung. Stand: 21.10.2026.
import one360 from './one360';
import type { WarehouseHeroResult } from '../../interfaces/warehouseHero';
import { getIdToken } from '../googleAuthSession';
import type { AxiosRequestConfig } from 'axios';
import type {
  DeviceTransport,
  SimState,
  SimDevice,
  SimEvent,
  SimOutcome,
} from '../../interfaces/deviceSimulation';
const base = '/api/v1/ops/warehouse/devices';
export function warehouseDevicesApi(mayAccess: () => boolean): DeviceTransport {
  async function request<T>(
    run: (config: AxiosRequestConfig) => Promise<T>,
  ): Promise<T> {
    if (!mayAccess())
      throw Object.assign(new Error('Bitte erneut anmelden.'), { status: 401 });
    const token = getIdToken();
    if (!token)
      throw Object.assign(new Error('Bitte erneut anmelden.'), { status: 401 });
    // Das Token gehört zum hier geprüften Konto, auch wenn Axios erst später sendet.
    return run({ headers: { Authorization: `Bearer ${token}` } });
  }
  return {
    syncHero: (articleId, mode, clarification) =>
      request((config) =>
        one360.post<WarehouseHeroResult>(
          '/api/v1/ops/warehouse/hero',
          { articleId, mode, ...clarification },
          config,
        ),
      ),
    state: () =>
      request(async (config) => {
        const state = await one360.get<SimState>(`${base}/snapshot`, config);
        if (
          state.contractVersion !== 1 ||
          state.simulation ||
          !Array.isArray(state.locations) ||
          !Array.isArray(state.articles) ||
          state.articles.some(
            (a) => !a.number || !a.unit || !Array.isArray(a.codes),
          )
        )
          throw new Error(
            'Die Geräteanbindung ist noch nicht bereit. Bitte die Lagerkraft informieren.',
          );
        return state;
      }),
    status: (id) =>
      request((config) =>
        one360.get<SimOutcome | null>(
          `${base}/bookings/${encodeURIComponent(id)}`,
          config,
        ),
      ),
    book: (operation) =>
      request((config) =>
        one360.post<SimOutcome>(`${base}/bookings`, operation, config),
      ),
    history: (id) =>
      request((config) =>
        one360.get<SimEvent[]>(
          `${base}/${encodeURIComponent(id)}/history`,
          config,
        ),
      ),
    search: (query, filter) =>
      request((config) =>
        one360.get<SimDevice[]>(
          `${base}?search=${encodeURIComponent(query)}${Object.entries(
            filter ?? {},
          )
            .map(([key, value]) => `&${key}=${encodeURIComponent(value)}`)
            .join('')}`,
          config,
        ),
      ),
  };
}
